// Module
var code = "<span aria-label=\"{{item[richDropdown.collectionKey || 'name']}}\"><span ng-bind=\"item[richDropdown.collectionKey || 'name']\"></span></span>";
// Exports
module.exports = code;